var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { staticClass: "inputs", attrs: { xs: "12" } },
                [
                  _c("w-input-currency", {
                    attrs: {
                      "currency-rate": _vm.currencyRate,
                      currency: _vm.value.CurrencyID,
                      label: _vm.$ct("purchase-trading-goods"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.VATPurchaseTradingGoods,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "VATPurchaseTradingGoods", $$v)
                      },
                      expression: "value.VATPurchaseTradingGoods",
                    },
                  }),
                  _c("w-input-currency", {
                    attrs: {
                      "currency-rate": _vm.currencyRate,
                      currency: _vm.value.CurrencyID,
                      label: _vm.$ct("services-and-costs"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.VATServicesAndCosts,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "VATServicesAndCosts", $$v)
                      },
                      expression: "value.VATServicesAndCosts",
                    },
                  }),
                  _c("w-input-currency", {
                    attrs: {
                      "currency-rate": _vm.currencyRate,
                      currency: _vm.value.CurrencyID,
                      label: _vm.$ct("buisiness-assets"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.VATBuisinessAssets,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "VATBuisinessAssets", $$v)
                      },
                      expression: "value.VATBuisinessAssets",
                    },
                  }),
                  _c("w-input-currency", {
                    attrs: {
                      "currency-rate": _vm.currencyRate,
                      currency: _vm.value.CurrencyID,
                      label: _vm.$ct("amount-import-within-eg"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.VATAmountImportWithinTheEG,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "VATAmountImportWithinTheEG", $$v)
                      },
                      expression: "value.VATAmountImportWithinTheEG",
                    },
                  }),
                  _c("w-input-currency", {
                    attrs: {
                      "currency-rate": _vm.currencyRate,
                      currency: _vm.value.CurrencyID,
                      label: _vm.$ct("amount-co-contracts"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.VATAmountCoContracts,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "VATAmountCoContracts", $$v)
                      },
                      expression: "value.VATAmountCoContracts",
                    },
                  }),
                  _c("w-input-currency", {
                    attrs: {
                      "currency-rate": _vm.currencyRate,
                      currency: _vm.value.CurrencyID,
                      label: _vm.$ct("amount-services-within-eg"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.VATAmountServicesWithingTheEG,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value,
                          "VATAmountServicesWithingTheEG",
                          $$v
                        )
                      },
                      expression: "value.VATAmountServicesWithingTheEG",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "4" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      label: _vm.$ct("subtractable-percent"),
                      fancy: "",
                      decimals: 1,
                    },
                    on: {
                      blur: function ($event) {
                        return _vm.onSubtractablePercentChanged()
                      },
                    },
                    model: {
                      value: _vm.subtractablePercent,
                      callback: function ($$v) {
                        _vm.subtractablePercent = $$v
                      },
                      expression: "subtractablePercent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "8" } },
                [
                  _c("w-input-currency", {
                    attrs: {
                      "currency-rate": _vm.currencyRate,
                      currency: _vm.value.CurrencyID,
                      label: _vm.$ct("subtractable"),
                      fancy: "",
                    },
                    on: {
                      blur: function ($event) {
                        return _vm.onVatSubtractableChanged()
                      },
                    },
                    model: {
                      value: _vm.value.VATSubtractable,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "VATSubtractable", $$v)
                      },
                      expression: "value.VATSubtractable",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { staticClass: "inputs", attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      label: _vm.labelNotSubstracted,
                      icon: "book",
                      fancy: "",
                    },
                    on: {
                      "icon-click": function ($event) {
                        _vm.toggleLedger82B = !_vm.toggleLedger82B
                      },
                      blur: function ($event) {
                        return _vm.onVatNotSubtractableChanged()
                      },
                    },
                    model: {
                      value: _vm.value.VATNotSubtractable,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "VATNotSubtractable", $$v)
                      },
                      expression: "value.VATNotSubtractable",
                    },
                  }),
                  _vm.toggleLedger82B
                    ? _c(
                        "div",
                        { staticClass: "info" },
                        [
                          _c("app-ledger-account-autocomlete", {
                            attrs: {
                              value: _vm.value.Ledger82B,
                              "add-remove-button": "",
                              label: _vm.$ct("not-subtractable-input-label"),
                              fancy: "",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setLedger82B($event)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("import-within-eg"), fancy: "" },
                    model: {
                      value: _vm.value.VATImportWithinTheEG,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "VATImportWithinTheEG", $$v)
                      },
                      expression: "value.VATImportWithinTheEG",
                    },
                  }),
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("co-contracts"), fancy: "" },
                    model: {
                      value: _vm.value.VATCoContracts,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "VATCoContracts", $$v)
                      },
                      expression: "value.VATCoContracts",
                    },
                  }),
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("import-outside-eg"), fancy: "" },
                    model: {
                      value: _vm.value.VATImportOutsideTheEG,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "VATImportOutsideTheEG", $$v)
                      },
                      expression: "value.VATImportOutsideTheEG",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { staticClass: "inputs", attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("leeggoed"), fancy: "" },
                    model: {
                      value: _vm.value.Leeggoed,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Leeggoed", $$v)
                      },
                      expression: "value.Leeggoed",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c("div", [
            _vm._v(_vm._s(_vm.$ct("total-booked", { value: _vm.totalBooked }))),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }